<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="navBar">
      <img class="homeImg" src="../../assets/img/talk/icon_4_18.png" alt />
      <div @click="goTalk">校园论坛</div>
      <img class="arrow" src="../../assets/img/talk/icon_4_27.png" alt />
      <div>帖子详情</div>
    </div>
    <!-- 帖子列表 -->
    <div class="tie_list" style="border: none">
      <div class="tie_item">
        <div class="tie_left">
          <img :src="imgUrl + detailInfo.header" alt />
          <div>{{ detailInfo.username }}</div>
          <div class="louzhu">楼主</div>
        </div>
        <div class="tie_tight">
          <div class="tie_title">
            <div>{{ detailInfo.title }}</div>
          </div>
          <div class="tie_desc">{{ detailInfo.content }}</div>
          <div class="tie_img">
            <img v-for="(key, val) in detailInfo.atlas" :key="val" :src="imgUrl + key" alt />
          </div>
          <div class="tie_btm">
            <div class="btm_left">{{ (detailInfo.addtime * 1000) | dateFormat }}</div>
            <div class="btm_right">
              <div class="btm_item">
                <img
                  v-if="!detailInfo.praise_check"
                  @click="like($event,detailInfo.id,1)"
                  class="img1"
                  src="../../assets/img/talk/icon_4_21.png"
                  alt
                />
                <img
                  v-else
                  @click="cancelLike($event,detailInfo.id,1)"
                  class="img1"
                  src="../../assets/img/talk/icon_4_22.png"
                  alt
                />
                <div>{{detailInfo.praise}}</div>
              </div>
              <div class="btm_item btm_item2">
                <img
                  @click="fabuShow2 = !fabuShow2"
                  class="img2"
                  src="../../assets/img/talk/icon_4_10.png"
                  alt
                />
                <div>{{ detailInfo.comment }}</div>
              </div>

              <div class="btm_item">
                <img class="img3" src="../../assets/img/talk/icon_4_11.png" alt />
                <div>{{ detailInfo.praise }}</div>
              </div>
            </div>
          </div>
          <div class="fabu_body" v-if="fabuShow2">
            <div class="fabu_content">
              <textarea placeholder="快来发表你的想法吧！" name id cols="30" rows="10" v-model="tieVal"></textarea>
              <div class="fabu_btm">
                <div class="fabu_box">
                  <div class="fabu_left">
                    <!-- <div class="img1">
                      <img src="../../assets/img/talk/icon_4_12.png" alt="" />
                    </div>
                    <div class="img2">
                      <img
                        v-if="imgShow"
                        @click="imgShow = false"
                        src="../../assets/img/talk/icon_4_15.png"
                        alt=""
                      />
                      <img
                        v-else
                        @click="imgShow = true"
                        src="../../assets/img/talk/icon_4_13.png"
                        alt=""
                      />
                    </div>-->
                  </div>
                  <div
                    class="fabu_rt"
                    @click="
                      goFaBu(detailInfo.id, detailInfo.id, detailInfo.type, 0)
                    "
                  >发表</div>
                </div>
                <div class="fabu_imgs" v-if="imgShow">
                  <div class="fabu_imgs_top">图片({{ imageUrlList.length }}/9)</div>
                  <div class="fabu_imgs_bd">
                    <div class="imgs_box">
                      <input
                        type="file"
                        accept="image/*"
                        @change="handleFile"
                        class="hiddenInput"
                        name="file"
                      />
                      <div class="img_list">
                        <div
                          @mouseenter="closeFlag = index"
                          @mouseleave="closeFlag = -1"
                          class="img_item"
                          v-for="(item, index) in imageUrlList"
                          :key="index"
                          alt
                        >
                          <img :src="item" />
                          <img
                            @click="closeImg(index)"
                            v-if="closeFlag == index"
                            class="close"
                            src="../../assets/img/talk/icon_4_17.png"
                            alt
                          />
                        </div>
                        <div @click.stop="uploadHeadImg" class="add_img">
                          <img src="../../assets/img/talk/icon_4_24.png" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 评论内容 -->
    <div class="pinglun_box">
      <div class="pinglun_top">
        <div>评论</div>
        <!-- <div class="look">
          <img src="../../assets/img/talk/icon_4_19.png" alt="" />
          只看楼主
        </div>-->
      </div>
      <!-- 评论列表 -->
      <div class="tie_list" v-for="(item, index) in pinglunList1" :key="index">
        <div class="tie_item">
          <div class="tie_left">
            <img :src="imgUrl + item.header" alt />
            <div>{{ index + 1 }}楼</div>
          </div>
          <div class="tie_tight">
            <div class="tie_title">
              <div style="color: #029aff">{{ item.username }}</div>
              <div>{{ (item.addtime * 1000) | dateFormat }}</div>
            </div>
            <div class="tie_desc">{{ item.content }}</div>
            <!-- <div class="tie_img">
            <img v-for="(item, index) in 6" :key="index" src="../../assets/img/talk/bg_4_1.png" alt="" />
            </div>-->
            <div class="answer_box" v-if="item.comment_list.length > 0">
              <div
                class="answer_item"
                v-for="(item1, index1) in item.comment_list"
                :key="index1"
                @click="showFabu(item.id, item1.u_id)"
              >
                <!-- <div>
                  <span style="color: #029aff">{{ item1.username }}</span>
                回复：
                {{ item1.content }}
                </div>-->
                <div>
                  <span style="color: #029aff">{{ item1.username }}</span> :
                  <span v-if="item1.p_username">
                    回复：
                    <span style="color: #029aff">
                      {{
                      item1.p_username
                      }}
                    </span>
                  </span>
                  {{ item1.content }}
                </div>
              </div>
              <!-- <div v-if="show" class="allAnswer" @click="closeMore">收起</div> -->
              <div class="allAnswer" @click="showMore">
                <!-- 共有{{ item.comment_list.length }}条回复> -->
              </div>
            </div>
            <div class="tie_btm">
              <div class="btm_left"></div>
              <div class="btm_right">
                <div class="btm_item btm_item2">
                  <img
                    @click="showFabu(item.id)"
                    class="img2"
                    src="../../assets/img/talk/icon_4_10.png"
                    alt
                  />
                </div>
                <div class="btm_item">
                  <img
                    v-if="item.praise_check"
                    @click="cancelLike($event,item.id,2)"
                    class="img1"
                    src="../../assets/img/talk/icon_4_22.png"
                    alt
                  />
                  <img
                    v-else
                    @click="like($event,item.id,2)"
                    class="img1"
                    src="../../assets/img/talk/icon_4_21.png"
                    alt
                  />
                  <div>{{item.praise}}</div>
                </div>
              </div>
            </div>
            <div class="fabu_body" v-if="item.fabuShow">
              <div class="fabu_content">
                <textarea placeholder="快来发表你的想法吧！" name id cols="30" rows="10" v-model="tieVal2"></textarea>
                <div class="fabu_btm">
                  <div class="fabu_box">
                    <div class="fabu_left">
                      <!-- <div class="img1">
                        <img src="../../assets/img/talk/icon_4_12.png" alt="" />
                      </div>
                      <div class="img2">
                        <img
                          v-if="imgShow"
                          @click="imgShow = false"
                          src="../../assets/img/talk/icon_4_15.png"
                          alt=""
                        />
                        <img
                          v-else
                          @click="imgShow = true"
                          src="../../assets/img/talk/icon_4_13.png"
                          alt=""
                        />
                      </div>-->
                    </div>
                    <div class="fabu_rt" @click="goFaBu(detailInfo.id, item.id, item.type, 1)">发表</div>
                  </div>
                  <div class="fabu_imgs" v-if="imgShow">
                    <div class="fabu_imgs_top">图片({{ imageUrlList.length }}/9)</div>
                    <div class="fabu_imgs_bd">
                      <div class="imgs_box">
                        <input
                          type="file"
                          accept="image/*"
                          @change="handleFile"
                          class="hiddenInput"
                          name="file"
                        />
                        <div class="img_list">
                          <div
                            @mouseenter="closeFlag = index"
                            @mouseleave="closeFlag = -1"
                            class="img_item"
                            v-for="(item, index) in imageUrlList"
                            :key="index"
                            alt
                          >
                            <img :src="item" />
                            <img
                              @click="closeImg(index)"
                              v-if="closeFlag == index"
                              class="close"
                              src="../../assets/img/talk/icon_4_17.png"
                              alt
                            />
                          </div>
                          <div @click.stop="uploadHeadImg" class="add_img">
                            <img src="../../assets/img/talk/icon_4_24.png" alt />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTalkDetail,
  goPinuLun,
  takePraise,
  clearPraise,
} from "../../assets/js/api.js";
import store from "store";
import Bus from "../../bus.js";
export default {
  data() {
    return {
      // 帖子评论
      tieVal: "",
      // 评论中评论
      tieVal2: "",
      file: "",
      // imgUrl: "http://education.hnzye.cn",
      detailInfo: "",
      id: "",
      show: false,
      answerList: [
        {
          id: 1,
          title: "好好学习",
        },
        {
          id: 2,
          title: "好好学习",
        },
        {
          id: 3,
          title: "好好学习",
        },
      ],
      answerList2: ["好好学习", "好好学习", "好好学习", "好好学习", "好好学习"],
      imgShow: false,
      fabuShow2: false,
      imageUrlList: [],
      closeFlag: -1,
      pinglunList1: [],
      u_id: "",
    };
  },
  created() {
    this.getDetail();
  },
  mounted() {
    Bus.$on("id", (data) => {
      store.set("f_id", data);
    });
    // this.pinglunList.map((x) => {
    //   this.$set(x, "fabuShow", false);
    // });
    window.scroll(0, 0);

  },
  methods: {
    like(e, id, type) {
      takePraise(id).then((res) => {
        if (res.code == 200) {
          console.log(res);
          if (type == 1) {
            this.detailInfo.praise_check = true;
            this.detailInfo.praise=this.detailInfo.praise-0+1
          } else {
            this.pinglunList1.forEach((item) => {
              if (item.id == id) {
                item.praise = item.praise - 0 + 1;
                item.praise_check = true;
              }
            });
          }

          console.log(this.pinglunList1);
        } else {
        }
      });
    },
    cancelLike(e, id, type) {
      console.log(type);
      clearPraise(id).then((res) => {
        if (res.code == 200) {
          console.log(res);
          if (type == 1) {
            this.detailInfo.praise_check = false;
            this.detailInfo.praise=this.detailInfo.praise-0-1
          } else {
            this.pinglunList1.forEach((item) => {
              if (item.id == id) {
                item.praise = item.praise - 0 - 1;
                item.praise_check = false;
              }
            });
          }

          console.log(this.pinglunList1);
        } else {
        }
      });
    },
    // 获取帖子详情
    getDetail() {
      getTalkDetail(store.get("f_id")).then((res) => {
        console.log(res);
        if (res.code == 200) {
          console.log("res.data===="+JSON.stringify(res.data))
          this.detailInfo = res.data;
          console.log("title==="+this.detailInfo.title)
          this.pinglunList1 = res.data.reply;
          this.pinglunList1.map((x) => {
            this.$set(x, "fabuShow", false);
          });
          console.log(this.detailInfo);
        }
      });
    },
    // 发表评论
    goFaBu(id, p_id, type, falg) {
      let content = "";
      console.log(this.son_id);
      if (falg == 0) {
        content = this.tieVal;
        if (!this.tieVal) {
          this.$message.error("请输入内容！");
          return;
        }
      } else {
        content = this.tieVal2;
        if (!this.tieVal2) {
          this.$message.error("请输入内容！");
          return;
        }
      }
      goPinuLun(content, "", type, id, p_id, this.u_id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message.success("评论发布成功！");
          this.tieVal = "";
          this.tieVal2 = "";
          this.getDetail();
        } else {
          this.$message.error(res.msg);
          return;
        }
      });
    },
    showFabu(item_id, u_id) {
      this.u_id = u_id;
      this.tieVal2 = "";
      this.pinglunList1.map((x) => {
        if (x.id == item_id) {
          if (x.fabuShow) {
            x.fabuShow = false;
          } else {
            x.fabuShow = true;
          }
        } else {
          x.fabuShow = false;
        }
      });
    },
    goTalk() {
      this.$emit("child-event", -1);
    },
    // 展开
    showMore() {
      this.answerList = this.answerList2;
      this.show = true;
    },
    // 收起
    closeMore() {
      this.answerList = this.answerList;
      this.show = false;
    },
    // 上传图片
    uploadHeadImg: function (e) {
      if (this.imageUrlList.length == 9) {
        this.$message.error("最多选择9张图片！");
        return;
      }
      this.$el.querySelector(".hiddenInput").click();
    },
    // 将头像显示
    handleFile: function (e) {
      console.log(e.target.files[0]);
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      this.file = file;
      var reader = new FileReader();
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.imageUrlList.push(res.result);
      };
      reader.readAsDataURL(file);
    },
    // 取消图片
    closeImg(i) {
      console.log(i);
      // this.imageUrlList.pop(i);
      this.imageUrlList.splice(i, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.navBar {
  width: 805px;
  // height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .homeImg {
    width: 16px;
    height: 15px;
    margin-right: 10px;
  }

  .arrow {
    width: 7px;
    height: 10px;
    margin: 0 10px;
  }

  div:nth-child(2) {
    color: #999999;
    cursor: pointer;
  }

  div:nth-child(4) {
    color: #029aff;
  }
}

.tie_list {
  // margin-bottom: 40px;
  border-bottom: 1px solid #eaeaea;

  .tie_item {
    padding: 25px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    margin-bottom: 10px;

    .tie_left {
      color: #333;
      font-size: 14px;
      text-align: center;
      margin-right: 20px;

      img {
        width: 54px;
        height: 54px;
        border-radius: 50%;
      }

      .louzhu {
        font-size: 14px;
        color: #029aff;
      }
    }

    .tie_tight {
      width: 100%;

      .tie_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        div:nth-child(1) {
          font-size: 18px;
          color: #333;
        }

        div:nth-child(2) {
          font-size: 14px;
          color: #999;
          // cursor: pointer;

          img {
            width: 15px;
            height: 17px;
            vertical-align: top;
          }
        }
      }

      .tie_desc {
        font-size: 14px;
        color: #656565;
        line-height: 2;
      }

      .answer_box {
        width: 100%;
        padding: 15px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 1.8;
        background-color: #f5f5f5;
        margin-top: 20px;
        color: #343434;

        .allAnswer {
          color: #029aff;
          cursor: pointer;
        }
        .answer_item {
          cursor: pointer;
        }
      }

      .tie_img {
        width: 380px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 20px 0;

        img {
          width: 120px;
          height: 120px;
          margin-bottom: 10px;
        }
      }

      .tie_btm {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;

        .btm_left {
          font-size: 14px;
          color: #9a9a9a;

          span {
            color: #0199ff;
            cursor: pointer;
          }
        }

        .btm_right {
          display: flex;
          align-items: center;

          .btm_item {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #999;

            img {
              margin-right: 8px;
            }

            .img1 {
              width: 19px;
              height: 19px;
              cursor: pointer;
            }

            .img2 {
              width: 18px;
              height: 16px;
              cursor: pointer;
            }

            .img3 {
              width: 12px;
              height: 16px;
            }
          }

          .btm_item2 {
            margin: 0 30px;
          }
        }
      }
    }
  }
}

.pinglun_box {
  width: 100%;
  margin-top: 10px;
  background-color: #fff;

  .pinglun_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 58px;
    border: 1px solid #eaeaea;
    font-size: 18px;
    color: #343434;
    padding: 0 25px;
    box-sizing: border-box;

    .look {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #9a9a9a;
      cursor: pointer;

      img {
        width: 26px;
        height: 16px;
        margin-right: 10px;
      }
    }
  }
}
.fabu_body {
  width: 100%;
  // background-color: #fff;
  // position: absolute;
  // bottom: -20px;
  // left: 0;
  // position: relative;
  // top: -10px;

  ::placeholder {
    //通过这个设置
    color: #999;
    font-size: 16px;
  }
  .fabu_content {
    position: relative;
    width: 100%;
    height: 120px;
    border: none;
    border: 1px solid #eaeaea;
    margin-top: 20px;
    // padding-top: 10px;
    // box-sizing: border-box;
    background-color: #f2f2f2;

    textarea {
      width: 100%;
      height: 80px;
      resize: none;
      outline: none;
      border: none;
      border-bottom: 1px solid #eaeaea;
      padding: 15px;
      box-sizing: border-box;
      background-color: #fff;
      vertical-align: top;

      ::placeholder {
        //通过这个设置
        color: #999;
        font-size: 16px;
      }
    }

    .fabu_btm {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      background-color: #fff;
      // overflow: hidden;

      .fabu_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 40px;
        background-color: #fff;

        .fabu_left {
          display: flex;
          align-items: center;

          img {
            cursor: pointer;
          }

          .img1 {
            width: 20px;
            height: 20px;
            margin: 0 20px;
          }

          .img2 {
            width: 22px;
            height: 18px;
            margin: 0 20px;
          }
        }

        .fabu_rt {
          width: 101px;
          height: 40px;
          line-height: 40px;
          background: #029aff;
          font-size: 18px;
          color: #fff;
          text-align: center;
          cursor: pointer;
        }
      }

      .fabu_imgs {
        position: absolute;
        top: 40px;
        left: 0;
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.1);

        .fabu_imgs_top {
          width: 100%;
          height: 40px;
          line-height: 40px;
          // border: 1px solid #eaeaea;
          border-bottom: 1px solid #eaeaea;
          border-top: 1px solid #eaeaea;
          font-size: 14px;
          color: #9a9a9a;
          padding: 0 20px;
          box-sizing: border-box;
        }

        .fabu_imgs_bd {
          display: flex;
          width: 100%;
          padding: 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #eaeaea;

          .imgs_box {
            // display: flex;
            // flex-wrap: wrap;
            // max-width: 380px;
            .img_list {
              display: flex;
              flex-wrap: wrap;
              max-width: 380px;

              .img_item {
                position: relative;
                flex: 0 0 31%;
                margin-right: 10px;
                margin-bottom: 10px;

                img {
                  width: 120px;
                  height: 120px;
                }

                .close {
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  z-index: 2;
                  width: 14px;
                  height: 14px;
                  cursor: pointer;
                }
              }

              .img_item:nth-child(3n) {
                margin-right: 0;
              }

              .add_img {
                width: 120px;
                height: 120px;
                background-color: #eaeaea;
                cursor: pointer;
                text-align: center;

                // margin-left: 10px;
                img {
                  width: 57px;
                  height: 57px;
                  margin-top: 30px;
                }
              }
            }

            input {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
